<script lang="ts">
	import { IconButton } from '@Shelly/shelly-design-system';
	import { profile_data } from 'src/stores/account/user';
	import { save_profile } from 'src/helpers/profile_helpers';

	const updateHomeData = () => {
		save_profile('showNewsletter', {
			seen: false,
		});

		profile_data.set({
			...$profile_data,
			showNewsletter: {
				seen: false,
			},
		});
	};
</script>

<IconButton class="mr-s" icon="fas fa-envelope" on:click={updateHomeData}
	>Reset Newsletter Pop-up</IconButton
>
